import "core-js/modules/es6.function.name";
import * as React from "react";
import { handleLineBreaks } from "../helpers/prismicHelpers";
import { RichText } from "prismic-reactjs";
import { Link } from "gatsby";
import "./expanders.scss";
import "./people.scss";
import { AppContext } from "../layout/shell";
export var People = function People(_ref) {
  var data = _ref.data;

  var _React$useContext = React.useContext(AppContext),
      isMobile = _React$useContext.isMobile;

  return /*#__PURE__*/React.createElement("div", {
    className: "people"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fixed-width"
  }, /*#__PURE__*/React.createElement("h2", null, data.primary.header), data.fields.map(function (person) {
    return /*#__PURE__*/React.createElement(Person, {
      isMobile: isMobile,
      photoUrl: person.photo['url'],
      name: person.name,
      content: person.bio,
      extraContent: person.bio_complete
    });
  }), !isMobile && /*#__PURE__*/React.createElement(Link, {
    className: "btn",
    to: data.primary.path
  }, data.primary.action)));
};

var Person = function Person(_ref2) {
  var photoUrl = _ref2.photoUrl,
      name = _ref2.name,
      content = _ref2.content,
      extraContent = _ref2.extraContent,
      isMobile = _ref2.isMobile;

  var _React$useState = React.useState(false),
      open = _React$useState[0],
      setOpen = _React$useState[1];

  return /*#__PURE__*/React.createElement("div", {
    className: "expander people-expander",
    "data-expanded": open
  }, /*#__PURE__*/React.createElement("img", {
    className: "person-photo",
    src: photoUrl,
    alt: name
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", null, handleLineBreaks(name)), /*#__PURE__*/React.createElement("p", null, handleLineBreaks(content)), /*#__PURE__*/React.createElement("div", {
    className: "p-extra",
    style: {
      maxHeight: open ? isMobile ? '1000px' : '600px' : '0'
    }
  }, RichText.render(extraContent)), /*#__PURE__*/React.createElement("div", {
    className: "expander-header-clicker",
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: "expander-button",
    src: require('../assets/images/expander.svg'),
    alt: "expander-arrow"
  }), /*#__PURE__*/React.createElement("span", null, "READ ", open ? 'LESS' : 'MORE'))));
};